import { render, staticRenderFns } from "./PriceTab.vue?vue&type=template&id=18c88b17&scoped=true"
import script from "./PriceTab.vue?vue&type=script&lang=js"
export * from "./PriceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c88b17",
  null
  
)

export default component.exports